import r2Project from '@/assets/service/r2Project'
import * as types from './mutation-types.js'

export default {
  fetchRole ({commit}, params){
    return r2Project.getRole(params).then((res) => {
      console.log('查询当前项目角色', res)
      commit(types.SET_ROLE, res.data)
    }).catch((e) => {
      console.log(e)
    })
  }
}

